import { LAYOUT } from '@admin/router/constant'

// LP资源位
const LpResourceRouter = {
  path: '/gmp',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/gmp/lpresource',
      name: 'LpResourceList',
      component: () => import('@admin/views/gmp/lpresource/list/index.vue'),
      meta: {
        title: 'LP运营资源位',
      },
    },
    {
      path: '/gmp/lpresource/edit',
      name: 'LpResourceEdit',
      component: () => import('@admin/views/gmp/lpresource/edit/index.vue'),
      meta: {
        title: 'LP运营资源位编辑',
      },
    },
  ],
}

export default LpResourceRouter
